<template>
  <section class="content-padding-gray">
    <div class="row">
      <div class="col-12 col-md-8 offset-md-2">
        <!-- Main content -->
        <div class="card panel-white">
          <div class="card-body">
            <div class="mb-2">PB #{{ preBooking.id }}</div>
            <h3>{{ preBooking.title }}</h3>
            <hr>
            <div>{{ $t('message.pre_booking.date') }}: {{ preBooking.cleaning_date | prettyDate }}</div>
            <div>{{ $t('message.pre_booking.duration') }}: {{ preBooking.work_hour }} {{ $tc('message.hour', preBooking.work_hour) }}</div>
            <div>{{ $t('message.pre_booking.location') }}: {{ preBooking.address }}</div>
            <hr>
            <div>{{ $t('message.pre_booking.description') }}: <br>
              {{ preBooking.description }}
            </div>
          </div>
        </div>

        <!-- Professionals -->
        <section class="mt-5" v-if="professionalPreBookings">
          <h3>{{ $t('message.pre_booking.interested_professionals') }}</h3>
          <div class="card panel-inbox">
            <div class="card-body no-padding">
              <ul class="list-unstyled">
                <li class="card-body" v-for="professional in professionalPreBookings">
                  <a :href="'/cleaner/'+professional.professional.id" target="_blank" class="text-message">
                    <div class="row">
                      <div class="col-2">
                        <div class="avatar-container small">
                          <img v-lazy="professional.professional.picture"
                               class="rounded-circle message-user-img" alt="beneat cleaner">
                        </div>
                      </div>
                      <div class="col-6">
                        <label>
                          {{ professional.professional.firstname }} {{ professional.professional.lastname }}
                        </label>
                        <div>
                          {{ professional.remark }}
                        </div>
                      </div>
                      <div class="col-4">
                        <div>
                          <a href="" @click.prevent="openProfessionalReviewsModal(professional.professional)">
                            <i class="fas fa-star text-orange"></i> {{ professional.professional.rating }}
                          </a>
                        </div>
                        <div class="mt-2">{{ $t('message.professional.bookings') }}: {{ professional.professional.job_qty }}</div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>

    <cleaner-reviews-modal ref="cleanerReviewsModal"/>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import CleanerReviewsModal from '../booking/components/CleanerReviewsModal'

  export default {
    components: {
      CleanerReviewsModal
    },
    data () {
      return {
        preBookingId: this.$route.params.id
      }
    },
    computed: {
      ...mapState('preBooking', [
        'preBooking',
        'professionalPreBookings'
      ])
    },
    methods: {
      openProfessionalReviewsModal (professional) {
        const professionalData = {
          id: professional.id,
          name: professional.firstname,
          picture: professional.picture
        }
        this.$refs.cleanerReviewsModal.setProfessionalData(professionalData)
      }
    },
    mounted () {
      this.$store.dispatch('preBooking/LOAD_PRE_BOOKING_DETAIL', this.preBookingId)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/preBooking/PreBookingDetail.vue